'use strict';

angular.module('mobile-apps')
	.directive('textareaAddHighlight',['EntryHighlight', function(EntryHighlight) {
		return {
			restrict: 'A',
			scope: {
				ngModel: '=',
				entryData: '=',
				languages: '='
			},
			replace: true,


			link: function (scope, elem, attrs) {

				// Create and append the other html elements behind the textarea
				// to display the highlights
				var parent = elem.parent();
				var backdrop = $('<div class="variable-highlight-backdrop"></div>');
				$(backdrop).prependTo(parent);

				var highlights = $('<div class="variable-highlights form-control"></div>');
				$(highlights).appendTo(backdrop[0]);


				/**
				 * Updates the text in the backdrop whenever the text in the
				 * textarea changes
				 */
				var inputCallback = function() {
					var text = elem.val();

					// Escape html to not render the actual html of the input
					var htmlEscapedBase = $("<span>").text(scope.entryData.baseValue).html();
					var htmlEscapedEntry = $("<span>").text(text).html();

					var data = {
						"languages": scope.languages
					};

					var highlightedText = EntryHighlight.highlightText(htmlEscapedBase, undefined, htmlEscapedEntry, 'entry', data, true, '-live');
					highlights.html(highlightedText);
				};

				// Quite often there is no data available when we load the
				// directive initially. For that reason do we wait till we
				// get valid data first.
				scope.$watch('ngModel', function() {

					if (!scope.ngModel && scope.ngModel !== '') {
						return;
					}

					inputCallback();

					// If the element is rtl we also set the backdrop to it
					// that the highlights get displayed correctly.
					if (backdrop.css('direction') !== 'rtl' && elem.css('direction') === 'rtl') {
						backdrop.css('direction', 'rtl');
					}
				});

			}
		};
	}]);
